import script from "./StrategyAuth.vue?vue&type=script&lang=ts&setup=true"
export * from "./StrategyAuth.vue?vue&type=script&lang=ts&setup=true"

import "./StrategyAuth.vue?vue&type=style&index=0&id=7e4dabd7&lang=scss"

const __exports__ = script;

export default __exports__